import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WEEKLY_OPTIONS } from '../../../contants/createBudget';
import {
  addFormData
} from '../../../features/createBudget/createBudgetSlice';
import BudgetAmountInput from '../BudgetAmountInput';
import BudgetNameInput from '../BudgetNameInput';
import WeekStartSelect from './WeekStartSelect';

const SetMonthlyWeeklyBudget = ({ type }) => {
  const { formData, amountError, nameError, uniqueNameError } = useSelector(
    state => state.createBudget,
  );

  const dispatch = useDispatch();

  const handleUpdateField = useCallback(
    (fieldName, value) => {
      dispatch(addFormData({ ...formData, [fieldName]: value }));
    },
    [dispatch, formData],
  );

  return (
    <>
      {type === 'weekly' && (
        <WeekStartSelect
          value={formData.week_start_day}
          options={WEEKLY_OPTIONS}
          onChange={(selected, meta) =>
            handleUpdateField(meta?.name || 'week_start_day', selected)
          }
        />
      )}

      <BudgetAmountInput
        value={formData.amount}
        error={amountError}
        onChange={val => handleUpdateField('amount', val)}
      />

      <BudgetNameInput
        value={formData.name}
        error={nameError || uniqueNameError}
        onChange={val => handleUpdateField('name', val)}
      />
    </>
  );
};

SetMonthlyWeeklyBudget.propTypes = {
  type: PropTypes.string.isRequired,
};


export default SetMonthlyWeeklyBudget;
